import { INomenclature, NomenclatureType, VariantClassificationState } from './types';

interface IFormatNomenclatureProps {
  limitToPrimaryNomenclatures?: boolean;
  formatAsShortName?: boolean;
}
// Note: we need to handle cases with multiple colons in the nomenclature, e.g.:
// "ENST00000342988:deletion of exons 1-10 (chr18.GRCh37:g.48400713_48599018delinsCAATTGT)" ->
// "deletion of exons 1-10 (chr18.GRCh37:g.48400713_48599018delinsCAATTGT)"
const getShortName = (name: string) => {
  const colonPos = name.indexOf(':');
  return colonPos >= 0 ? name.substring(colonPos + 1) : name;
};

export const formatNomenclatures = (
  nomenclatures: INomenclature[],
  type: NomenclatureType,
  options?: IFormatNomenclatureProps
) => {
  const filteredNomenclaturesByType = nomenclatures.filter(
    (nomenclature) => nomenclature.type === type
  );
  const filteredNomenclatures = options?.limitToPrimaryNomenclatures
    ? filteredNomenclaturesByType.filter((nomenclature) => nomenclature.is_primary)
    : filteredNomenclaturesByType;
  return filteredNomenclatures
    .map((nomenclature) => {
      return options?.formatAsShortName ? getShortName(nomenclature.name) : nomenclature.name;
    })
    .join(', ');
};

export const formatNomenclaturesToDisplay = (
  nomenclatures: INomenclature[],
  variantIsCopyNumber: boolean
) => {
  const nomenclatureTypesToDisplay = variantIsCopyNumber
    ? [NomenclatureType.EXON, NomenclatureType.CHGVS]
    : [NomenclatureType.CHGVS, NomenclatureType.PHGVS];
  return nomenclatureTypesToDisplay
    .map((nomenclatureType) =>
      formatNomenclatures(nomenclatures, nomenclatureType, {
        limitToPrimaryNomenclatures: true,
        formatAsShortName: true,
      })
    )
    .filter((x) => x);
};

export const formatStateQueryParam = (state: string) => {
  if (state === 'all') {
    return;
  }
  // Rereview is not a true state on the Variant Classification model's FSM
  // Rereview variant classifications includes variant classifications in any state other than 'classified'
  if (state === VariantClassificationState.REREVIEW) {
    return `${VariantClassificationState.NEW},${VariantClassificationState.IN_PROGRESS},${VariantClassificationState.INTERPRETED}`;
  }
  return state;
};
